import '@fontsource/fredoka';
import '@fontsource/dm-sans';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import GeneratorPage from "@/pages/GeneratorPage";
import EditorPage from "@/pages/EditorPage";
import WaitlistPage from "@/pages/WaitlistPage";
import ThankYouPage from "@/pages/ThankYouPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <HelmetProvider>
    <div className="App min-h-screen bg-[#FDFBF7]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/create" element={<GeneratorPage />} />
          <Route path="/editor/:projectId" element={<EditorPage />} />
          <Route path="/waitlist/:projectId" element={<WaitlistPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
    </HelmetProvider>
  );
}

export default App;
